import styled from "styled-components";

export const Wrapper = styled.div`
  .ant-input-filled:focus, .ant-input-filled:focus-within {
    outline: 0;
    border-color: #e1e1e1;
    background-color: var(--app-surface);
  }
`;